import Vue from "vue"
import VueAxios from "vue-axios"
import Http from "@/lib/Http"

Vue.use(VueAxios, Http)
